import Vue from 'vue';

Vue.component('cost-good-sold-index', () =>
    import(/* webpackChunkName: 'cost-good-sold-index' */ './cost-good-sold-index.vue'),
);
